export default [
  {
    text1: "A One Stop Branding Agency in Indonesia",
    head: "PT. Sinar Media Digitama aims to offer 360-degree marketing services for creative business owners looking for a one-stop shop for their marketing campaign needs.",
    subhead:
      "We strive to be your professional partner in helping you develop your brand or product to shine forever. This is in line with our business goal of consistently prioritizing the value of every service and client satisfaction.",
    trihead: "We are confident that these efforts will provide outstanding outcomes for your brand in the future."
    },
  {
    text1: "A One Stop Branding Agency in Indonesia",
    head: "PT Sinar Media Digitama menghadirkan jasa layanan pemasaran secara 360-degree atau menyeluruh dalam segala sisi, memberikan para pengusaha bisnis kreatif satu tempat (one-stop shop) yang mencakup seluruh kebutuhan pemasaran mereka.",
    subhead:
      "Kami berusaha untuk selalu menjadi rekan profesional Anda dalam membangun suatu brand atau produk untuk menjadi yang terdepan sampai kapan pun. Ini menjadi salah satu tujuan bisnis kami untuk selalu mengedepankan kepuasan klien dalam setiap pelayanan kami.",
    trihead: "Kami yakin upaya ini akan memberikan hasil yang luar biasa untuk brand Anda di masa mendatang."
  },
];
